/**
 * The module's permissions. Values, not types: the backend's manifest
 * registers them and the frontend gates on the same strings.
 */
export const CURRENCY_PERMISSIONS = {
    /** See the rates, import them, set and delete them by hand, lock a currency. */
    ADMIN: 'currency.admin',
};
/** What every stored rate is quoted in: units of this per one unit of the currency. */
export const CURRENCY_BASE = 'CZK';
/** Bounds the server enforces, exported so a form can show them first. */
export const CURRENCY_LIMITS = {
    /** Calendar days one import may cover, `from` and `to` included. */
    importDays: 366,
    /** Significant digits a rate keeps. */
    rateDigits: 10,
};
/** The source key a rate set by hand carries. Never a key in the source registry. */
export const MANUAL_RATE_SOURCE = 'manual';
//# sourceMappingURL=currency.js.map